export default "__VITE_ASSET__CzTzO4P2__"